import React, { useEffect, useState } from "react";
import ReturnImage from "../functions/image";
import { NavLink } from "react-router-dom";

const Offcanvas = ({title, description, images, active, id, type, iframe, maquetteUrl, maquetteImgUrl, url}) => {
    const [imagesList, setImagesList] = useState([]);
    const [twoColumnClass, setTwoColumnClass] = useState("mek-offcanvas-images");

    console.log(images);

    function removeOffCanvas() {
        document.querySelector('.mek-offcanvas').dataset.active = false;
    }

    useEffect(() => {
        if (type == 'image') {
            setTwoColumnClass('mek-offcanvas-image-solo');
        }

        if (type == 'video') {
            setTwoColumnClass('mek-offcanvas-video');
        }

        if (type == 'maquette') {
            setTwoColumnClass('mek-offcanvas-maquette');
        }

        if (type == 'site') {
            setTwoColumnClass('mek-offcanvas-website');
        }
    }, []);

    return (
        <div className="mek-offcanvas pt-sm-4 pb-sm-4 pt-lg-5 pb-lg-5 px-4 px-lg-5 py-4 py-lg-5 text-white" data-active={active} id={id}>
            <h2 className="mek-offcanvas-title text-center col-12 mb-5">{title}</h2>
            <div className="mek-offcanvas-container col-12 row">
                <div className="mek-offcanvas-description col-12 col-lg-5">
                    <div dangerouslySetInnerHTML={{ __html: description }} />
                </div>
                {type == null && images?.length > 0 && (
                    <div className={`${twoColumnClass} col-12 col-lg-7`}>
                        {images.map((image, index) => (
                            <div className={`mek-offcanvas-image-contain`}>
                                <ReturnImage
                                 imageName={image.src}
                                 classname="mek-offcanvas-image-single"
                                 alt={image.alt} />
                            </div>
                        ))}
                    </div>
                )}
                {type == "image" && images?.length > 0 && (
                    <div className={`${twoColumnClass} col-12 col-lg-7`}>
                        {images.map((image, index) => (
                            <div className={`mek-offcanvas-image-contain`}>
                                <ReturnImage
                                 imageName={image.src}
                                 classname="mek-offcanvas-image-single"
                                 alt={image.alt} />
                            </div>
                        ))}
                    </div>
                )}
                {type == "video" && iframe !== "" && (
                    <div className={`${twoColumnClass} col-12 col-lg-7`}>
                        <div className={`mek-offcanvas-video-contain`} dangerouslySetInnerHTML={{__html: iframe}} />
                    </div>
                )}
                {type == "maquette" && maquetteUrl !== "" && (
                    <div className={`${twoColumnClass} col-12 col-lg-7`}>
                        <div className={`mek-offcanvas-maquette-contain`}>
                            <NavLink to={maquetteUrl} target="_blank" rel="noopener noreferrer">
                                <ReturnImage
                                 imageName={images[0].src}
                                 classname="mek-offcanvas-preview"
                                 alt={images[0].alt} />
                            </NavLink>
                        </div>
                    </div>
                )}
                {type == "site" && url !== "" && (
                    <div className={`${twoColumnClass} col-12 col-lg-7`}>
                        <div className={`mek-offcanvas-website-contain`}>
                            <NavLink to={url} target="_blank" rel="noopener noreferrer">
                                <ReturnImage
                                 imageName={images[0].src}
                                 classname="mek-offcanvas-preview"
                                 alt={images[0].alt} />
                            </NavLink>
                        </div>
                    </div>
                )}
            </div>
            <svg id={id} onClick={removeOffCanvas} className="mek-offcanvas-close" width="33" height="30" viewBox="0 0 33 30" xmlns="http://www.w3.org/2000/svg">
                <path d="M1 6.23077L10.3939 15.4615L1 24.6923L7.26263 29L16.0303 20.3846L24.798 29L32 24.6923L22.6061 15.4615L32 6.23077L24.798 1L16.0303 9.92308L7.26263 1" />
            </svg>
            <ReturnImage
             imageName="mustafa-suisse"
             classname="mek-offcanvas-background"
             alt="Image de fond" />
        </div>
    )
}

export default Offcanvas;